import { joinString } from '../shared/utils';
import { containersApi, containersApiBlob } from './api';
import { sortOptions } from './options';

export const VendorsAPI = {
  lookupVendorsBySearchString: (searchString) =>
    containersApi.get(`vendors/lookup?searchString=${searchString}`),
  getVendorByVendorId: (vendorId) => containersApi.get(`vendors/${vendorId}`),
  getPurchaseOrdersByVendorId: (vendorId) =>
    containersApi.get(`vendors/${vendorId}/purchaseOrders`),
  getVendorItemsBySupplierIds: ({ vendorId }) =>
    containersApi.post(`vendors/items`, {
      vendorId,
    }),
  getDocumentLinks: (vendorId) =>
    containersApi.get(`vendors/${vendorId}/documentLinks`),
  getVendorDocumentLinkAreas: () =>
    containersApi.get(`vendors/documentLinks/areas`),
  addDocumentLinks: ({
    updatedDocumentLinks,
    newDocumentLinks,
    vendorId,
    vendorAreas,
    supplierAreas,
  }) =>
    containersApi.post(`vendors/documentLinks`, {
      updatedDocumentLinks,
      newDocumentLinks,
      vendorId,
      vendorAreas,
      supplierAreas,
    }),
  viewDocumentLinksFile: ({ rowIndex, supplierId, vendorId }) =>
    containersApiBlob.get(
      `vendors/documentLinks/${vendorId}${
        supplierId ? `/supplier/${supplierId}` : ''
      }/row/${rowIndex}`
    ),
  getPurchaseOrderPdf: ({ poId, reprintFlag }) =>
    containersApiBlob.get(
      `vendors/purchaseOrders/${poId}/pdf?reprint=${
        reprintFlag ? reprintFlag : 'Y'
      }&transmitDocLinks=Y`
    ),
  sendPurchaseOrderEmail: ({ poId, emailForm, orderNo, reprintFlag }) =>
    containersApi.post(`vendors/purchaseOrders/${poId}/email`, {
      emailForm: emailForm,
      orderNo: orderNo,
      reprintFlag: reprintFlag,
      poId: poId,
    }),

  //vendor crud
  // getVendorNoteById: (vendorId) =>
  //   containersApi.get(`vendors/${vendorId}/notes`),
  // editOrDeleteVendorNote: (note) => containersApi.put(`vendors/notes`, note),
  // getVendorNoteSelectAreas: () => containersApi.get(`vendors/noteAreas`),
  // addVendorNote: (note, vendorId) =>
  //   containersApi.post(`vendors/notes`, { note, vendorId }),

  //supplier crud
  // getSupplierNoteById: (supplierIds) =>
  //   containersApi.post(`suppliers/notes`, { supplierIds }),
  // editOrDeleteSupplierNote: (note) =>
  //   containersApi.put(`suppliers/notes`, note),
  // getSupplierNoteSelectAreas: () => containersApi.get(`suppliers/noteAreas`),
  // addSupplierNote: (note) => containersApi.post(`suppliers/addNotes`, { note }),

  getSupplierDocumentLinkAreas: () =>
    containersApi.get(`suppliers/documentLinks/areas`),
  getSupplierPurchaseHistory: (supplierId) =>
    containersApi.get(`suppliers/${supplierId}/purchases`),

  //purchase history
  getPurchaseHistory: (vendorId, supplierIds) =>
    containersApi.get(
      `vendors/purchases?vendorId=${vendorId}&supplierIds=${JSON.stringify(
        supplierIds || []
      )}`
    ),

  updateVendorGuideFields: (vendorId, udFields) =>
    containersApi.put(`vendors/${vendorId}/udFields`, udFields),

  // vendor warehouse items
  getVendorWarehouseItems: (vendorId, itemId) =>
    containersApi.get(
      `vendors/${vendorId}/inventory/details/?itemId=${itemId || ''}`
    ),
  existingCapabilities: () =>
    containersApi.get(`suppliers/supplierCapabilities`),

  updateCapabilities: ({ supplierId, capabilities }) =>
    containersApi.post(`suppliers/${supplierId}/capabilities`, {
      capabilities,
    }),
  createContact: ({ supplierId, contact }) =>
    containersApi.post(`suppliers/${supplierId}/contact`, {
      contact,
    }),
  updateSupplier: (supplierId, fields) =>
    containersApi.put(`suppliers/${supplierId}`, fields),
  deleteSupplier: (supplierId) =>
    containersApi.delete(`suppliers/${supplierId}`),
  //todo: not sure if this one is needed here
  getSuppliersByLocation: (supplierId, invMastUid) =>
    containersApi.get(
      `suppliers/${supplierId}/items/${invMastUid}/supplierByLocation`
    ),
  addExistingSupplierToItem: ({
    supplierId,
    previousSupplierId,
    itemInvMastUids,
  }) =>
    containersApi.post(`suppliers/item/updateSupplierOnItem`, {
      supplierId,
      previousSupplierId,
      itemInvMastUids,
    }),
};

export const getVendorLookupOptions = async ({ searchString }) => {
  const { data: vendors } = await VendorsAPI.lookupVendorsBySearchString(
    searchString
  );

  vendors?.forEach((vendor) => {
    vendor.type = 'vendor';
    vendor.value = vendor.vendor_id;
    vendor.label = joinString([
      `${vendor.vendor_name} (${vendor.vendor_id})`,
      vendor?.supplier_id &&
        `${vendor?.supplier_name} (${vendor?.supplier_id})`,
      joinString(
        [
          vendor.mail_address1,
          vendor.mail_city,
          vendor.mail_state,
          vendor.mail_postal_code,
        ],
        ', '
      ),
    ]);
  });

  return sortOptions(vendors);
};
